export const WINDOW_EVENTS = {
  UPDATE_UNREAD_STATUS: "updateUnreadStatus",
  OPEN_PAGE_BUILDER: "openPageBuilder",
  OPEN_SUBSCRIBER_PROFILE: "openSubscriptionProfile",
  PROMPT_PUSH_PERMISSION: "promptPushPermisson",
  DIRECT_MESSAGE_SUBSCRIBER: "directMessageSubscriber",
  SUBSCRIBER_PROFILE_LOADED: "subscriberProfileLoaded",
};

export const APP_BRIDGE_MESSAGES = {
  INITIALIZE: "INITIALIZE",
  INITIALIZED: "INITIALIZED",
  SET_PROPS: "SET_PROPS",
  SET_TEMPLATE: "SET_TEMPLATE",
  SET_GLOBAL_STATE: "GLOBAL_STATE",
  SET_ACCESS: "SET_ACCESS",
  SET_PATH: "SET_PATH",
  SET_LAYOUT: "SET_LAYOUT",
  BRIDGE_READY: "BRIDGE_READY",
  BLOCK_REPOSITIONED: "BLOCK_REPOSITIONED",
  SETUP_SORTING: "SETUP_SORTING",
  PAGE_CHANGE_START: "PAGE_CHANGE_START",
  PAGE_CHANGE_FINISH: "PAGE_CHANGE_FINISH",
  DRAG_TARGET_DROPPED: "DRAG_TARGET_DROPPED",
  GENERATE_BLOCK_IMAGE: "GENERATE_BLOCK_IMAGE",
  BLOCK_IMAGE_GENERATED: "BLOCK_IMAGE_GENERATED",
};
